var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#starteda)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E0E5EE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#startedb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#475569",
    fillRule: "evenodd",
    d: "M7.771 9.632 6.366 8.227c.154-.26.308-.527.461-.792.508-.883 1.004-1.745 1.469-2.194 1.262-1.262 2.99-.53 2.99-.53s.732 1.729-.53 2.99c-.444.461-1.293.95-2.17 1.455a55.18 55.18 0 0 0-.815.476Zm1.07-3.267a.79.79 0 1 1 1.582 0 .79.79 0 0 1-1.582 0ZM6.796 6.25c-.71-.188-1.374.161-1.965.703a.24.24 0 0 0 .045.382l.952.574.001-.002c.138-.23.291-.497.447-.767.178-.308.358-.621.52-.89Zm1.294 3.92.574.953a.24.24 0 0 0 .382.044c.542-.59.891-1.256.702-1.965-.26.157-.535.315-.806.472l-.042.023c-.274.158-.546.315-.808.472l-.002.001Zm-2.281-.998a1 1 0 0 1 .7 1.73c-.11.107-.284.19-.445.254a5.357 5.357 0 0 1-.55.179 7.42 7.42 0 0 1-.49.116 2.949 2.949 0 0 1-.235.036.343.343 0 0 1-.1-.011.254.254 0 0 1-.12-.078c-.04-.048-.052-.098-.055-.11a.278.278 0 0 1-.005-.088 3.186 3.186 0 0 1 .037-.231c.027-.132.067-.306.118-.489.05-.182.11-.377.179-.547.064-.16.147-.333.253-.444a1 1 0 0 1 .713-.317Z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "starteda"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "startedb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.5 4.5h7v7h-7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarted);
export default __webpack_public_path__ + "static/media/started.4e82e11356cdcfaea194e4a7b055e346.svg";
export { ForwardRef as ReactComponent };